import React, { memo } from "react";
import styled from "styled-components";
import { Map } from "@talentbait/shared-components";
import CampaignWidgetLayout from "./CampaignWidgetLayout";

const StyledCampaignMap = styled(CampaignWidgetLayout)`
  .campaign-map {
    width: 100%;
    height: 100%;
  }
`;

const CampaignMap = ({ campaign = {} }) => {
  return (
    <StyledCampaignMap>
      <Map className="campaign-map" locations={campaign.locations} />
    </StyledCampaignMap>
  );
};

export default memo(CampaignMap);
